export const ChineseTitleFormat = (title: string) => {
    if(title.includes('及')){
        return title.split('及').join('<br>及')
    }
    return title
}